document.addEventListener('DOMContentLoaded', function() {  
    let open_filter = document.querySelector('.title-filter');  
    let title_filter = document.querySelectorAll('.Collection-filter-item .new-spirit');  
    let filter_float = document.querySelector('.filter-container');  

    // Toggle filter  
    title_filter.forEach(function(item) {  
        item.addEventListener('click', function() {  
            item.parentElement.classList.toggle('active');  
        });  
    });  

    // Toggle filter  
    open_filter.addEventListener('click', function() {  
        open_filter.parentElement.classList.toggle('active');  
        updateFilterPosition();  
    });  

    function updateFilterPosition() {  
        let offsetHeight = filter_float.offsetHeight;  
        let top_filter = filter_float.offsetTop;  
        return top_filter + offsetHeight;  
    }  

    let distance_filter = updateFilterPosition();  
    let lastScrollTop = 0; 
    const tolerance = 40; 

    window.addEventListener('scroll', function() {  
        let scroll = window.scrollY;  
        distance_filter = updateFilterPosition();  

        if (scroll >= distance_filter - tolerance && scroll <= distance_filter + tolerance) {  
            if (open_filter.parentElement.classList.contains('active')) {  
                open_filter.parentElement.classList.remove('active');  
            }  
        }  

        if (scroll >= distance_filter) { 
            if (scroll > lastScrollTop) {  
                filter_float.classList.remove('up'); 
            } else {  
                filter_float.classList.add('up'); 
            }  

            filter_float.classList.add('fixed');  
        } else {  
            filter_float.classList.remove('fixed');  
        }  

        lastScrollTop = scroll;  
    });  
});